import React from 'react';
import { BrandColor } from '@Shared.Angular/@types/brandColor';

export type CreationHubItemProps = {
  iconClass: string;
  title: string;
  description: string;
  actionText?: string;
  color?: BrandColor;
  isDisabled?: boolean;
  onClick: () => void;
};

export const CreationHubItem = ({
  iconClass,
  title,
  description,
  actionText,
  color,
  isDisabled,
  onClick
}: CreationHubItemProps) => {
  const colorModifier = color ? ` creation-hub-item--${color}` : '';

  return (
    <div
      className={`creation-hub-item${colorModifier} hover-shadow ${
        isDisabled ? 'creation-hub-item--disabled' : ''
      }`}
      onClick={isDisabled ? undefined : onClick}
      aria-disabled={isDisabled}
      role="button"
      data-testid={`creation-hub-item-${title
        .toLowerCase()
        .replace(/\s+/g, '-')}`}
    >
      <div className="creation-hub-item__icon-wrapper">
        <i className={`fa-light ${iconClass} creation-hub-item__icon`} />
      </div>
      <span className="creation-hub-item__title">{title}</span>
      <p className="creation-hub-item__description">{description}</p>
      {actionText && (
        <span className="creation-hub-item__action-link">
          {actionText}{' '}
          <span className="fa-light fa-arrow-right creation-hub-item__action-arrow"></span>
        </span>
      )}
    </div>
  );
};
